import React, { useContext, useEffect } from "react";
import {
  Drawer,
  List,
  Typography,
  Divider,
  IconButton,
} from "@material-ui/core";
import MenuIcon from "@material-ui/icons/Menu";
import { push } from "connected-react-router";
import { useDispatch, useSelector } from "react-redux";
import Context from "../../layouts/context";
import Logo from "../../assets/logo.png";
import {
  holdingsMenu,
  publicInstrument,
  useMenu,
  settingItem,
  splitInstrumentMenuItem,
  ProviderErrorList,
} from "./menu";
import { BaseMenuItem } from "./menu-item";
import menuStyles from "./menu.less";
import { MenuVersion } from "./menu-version";
import { MenuBottom } from "./menu-bottom";
import { MobileDevice } from "../hooks/responsive";

function DrawerMenu() {
  const dispatch = useDispatch();
  const redux = useContext(Context);
  const { ownerUser } = useSelector((state) => ({
    ownerUser: state.global.ownerUser,
  }));

  const menu = useMenu();

  const onClickMenu = (item) => {
    if (item.path) {
      pushOn(item.path);
    }
  };

  const pushOn = (path) => {
    dispatch({ type: "TOGGLE_SIDEBAR_COLLAPSED" });
    dispatch(push(path));
  };

  const closeMenu = () => {
    dispatch({ type: "TOGGLE_SIDEBAR_COLLAPSED" });
  };

  return (
    <div id="basemenu" className={menuStyles.menu}>
      <Drawer
        open={redux.isMobile ? redux.collapsed : true}
        onClose={closeMenu}
        className={menuStyles.drawer}
        variant={redux.isMobile ? "temporary" : "permanent"}
        classes={{
          paper: menuStyles.drawerPaper,
        }}
      >
        <div className={menuStyles.menuWrapper}>
          <div>
            <List disablePadding>
              <MobileDevice>
                <div className={menuStyles.logo}>
                  <div className={menuStyles.logoWrapper}>
                    <img alt="logo" src={Logo} />
                    <Typography
                      variant="h4"
                      color="primary"
                      className={menuStyles.navLogo}
                    >
                      EXIRIO
                    </Typography>
                  </div>
                  <IconButton onClick={closeMenu}>
                    <MenuIcon />
                  </IconButton>
                </div>
              </MobileDevice>
              <BaseMenuItem menu={publicInstrument} onClick={onClickMenu} />
              <BaseMenuItem menu={settingItem} onClick={onClickMenu} />
              <BaseMenuItem
                menu={splitInstrumentMenuItem}
                onClick={onClickMenu}
              />
              <BaseMenuItem menu={ProviderErrorList} onClick={onClickMenu} />
              {/* <BaseMenuItem
                menu={connectionSessionMenuItem}
                onClick={onClickMenu}
              /> */}
              {/* <BaseMenuItem menu={holdingsMenu} onClick={onClickMenu} /> */}
              {/* {menu.map((item) => (
                <BaseMenuItem key={item.id} menu={item} onClick={onClickMenu} />
              ))} */}
            </List>
          </div>
          <div>
            <Divider />
            <MobileDevice>
              <MenuBottom onClick={onClickMenu} />
              <Divider />
            </MobileDevice>
            <MenuVersion />
          </div>
        </div>
      </Drawer>
    </div>
  );
}

export default React.memo(DrawerMenu);
